import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'RiskAssessmentQuestion',
    column_type: 'id',
  },
  created_at: {
    model_name: 'RiskAssessmentQuestion',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'RiskAssessmentQuestion',
    column_type: 'datetime',
  },
  content: {
    model_name: 'RiskAssessmentQuestion',
    column_type: 'string',
  },
  position: {
    model_name: 'RiskAssessmentQuestion',
    column_type: 'integer',
  },
  kind: {
    model_name: 'RiskAssessmentQuestion',
    column_type: 'enum',
  },
  risk_assessment_options: {
    model_name: 'RiskAssessmentQuestion',
    column_type: 'has_many',
    extra: {
      association_name: 'risk_assessment_options',
      model_name: 'RiskAssessmentOption',
      foreign_key: 'risk_assessment_question_id',
    },
  },
  risk_assessment_option_ids: {
    model_name: 'RiskAssessmentQuestion',
    column_type: 'has_many',
    extra: {
      association_name: 'risk_assessment_options',
      model_name: 'RiskAssessmentOption',
      foreign_key: 'risk_assessment_question_id',
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
